'use strict';


app.factory('Auth', ['$http', 'localStorageService', '$rootScope', '$location', 'Popup', '$pusher', 'env_config',
    function ($http, localStorageService, $rootScope, $location, Popup, $pusher, env_config) {
        var service = {};

        /**
         * Login user
         * 
         * @param  string   username
         * @param  string   password
         * @param  Function callback
         */
        service.login = function (username, password, callback) {

            if( this.reloadPageIfUserIsLogedIn() ) return;

            $http.post(env_config.api_url + 'users/login', { username: username, password: password, dev:'web-app' })
                .success(function (resp, status) {
                    callback(resp, status);
                })
                .error(function(resp, status){
                    callback(resp, status);
                });
        };


        /**
         * Register user
         * 
         * @param  Object   user_data
         * @param  Function callback
         */
        service.register = function (user_data, callback) {

            if( this.reloadPageIfUserIsLogedIn() ) return;

            // set device
            user_data.dev = 'web-app';

            $http({
                method: 'POST',
                url: env_config.api_url + 'users',
                headers: { 'Content-Type': undefined },
                data: user_data,
                transformRequest: function (data, headersGetter) {
                    var formData = new FormData();
                    angular.forEach(data, function (value, key) {
                        formData.append(key, value);
                    });

                    var headers = headersGetter();
                    delete headers['Content-Type'];

                    return formData;
                }
            })
            .success(function (resp, status) {
                callback(resp, status);
            })
            .error(function(resp, status){
                callback(resp, status);
            });
        };

        /**
         * Verify user
         *
         * @param  Object   user_data
         * @param  Function callback
         */
        service.verifyRegister = function (user_data, callback) {

            if( this.reloadPageIfUserIsLogedIn() ) return;

            // set device
            user_data.dev = 'web-app';

            $http({
                method: 'POST',
                url: env_config.api_url + 'users/verify-registration',
                headers: { 'Content-Type': undefined },
                data: user_data,
                transformRequest: function (data, headersGetter) {
                    var formData = new FormData();
                    angular.forEach(data, function (value, key) {
                        formData.append(key, value);
                    });

                    var headers = headersGetter();
                    delete headers['Content-Type'];

                    return formData;
                }
            })
                .success(function (resp, status) {
                    callback(resp, status);
                })
                .error(function(resp, status){
                    callback(resp, status);
                });
        };


        /**
         * login with facebook
         * 
         * @param  String accessToken
         */
        service.fbConnect = function(accessToken, callback){

            if( this.reloadPageIfUserIsLogedIn() ) return;

        	$http.post(env_config.api_url + 'users/fbconnect', { fbtoken: accessToken })
        		.success(function (resp, status) {
                    callback(resp, status);
                })
                .error(function(resp, status){
                    callback(resp, status);
                });
        }


        /**
         * set credentials
         * 
         * @param Object user
         */
        service.setCredentials = function(user) {
            $rootScope.globals.currentUser = user;

            $http.defaults.headers.common['Authorization'] = 'Basic ' + user.loginToken;
            localStorageService.set('globals', $rootScope.globals);
        };


        /**
         * clear credentials
         */
    	service.clearCredentials = function () {
            $rootScope.globals = {};
            localStorageService.clearAll();

            delete $rootScope.braintree;
            
            $http.defaults.headers.common.Authorization = 'Basic';
        };


        /**
         * forgot password
         * 
         * @param  String email
         */
        service.forgotPassword = function(email, callback){
        	$http.post(env_config.api_url + 'users/recovery', { email: email })
        		.success(function (resp, status) {
                    callback(resp, status);
                })
                .error(function(resp, status){
                    callback(resp, status);
                });
        };


        /**
         * redirect if user is already logged in
         */
        service.redirectIfLoggedIn = function(){
            if ($rootScope.globals.currentUser) {
                var intended = $rootScope.globals.intended;

        		if(intended){
        			// go to the page where user intended to go
        			delete $rootScope.globals.intended;

        			$location.path( intended );
        		}
        		else{
                    // check in which flow the user is
                    if($rootScope.globals.flow == 'ticketing'){
                        // redirect to ticketing
                        $location.path('/tickets/' . $rootScope.globals.ticketedEvent.event.slug);
                    }else{
                        // otherwise redirect to landing page
                        $location.path('/');
                    }
        		}
        	}
        };


        /**
         * if user is already logged in in another tab just reload
         * the page and use that data from local storage
         */
        service.reloadPageIfUserIsLogedIn = function(){

            var globals = localStorageService.get('globals');

            if( globals != null && typeof globals.currentUser != 'undefined'){
                Popup.error('You are already logged in as '+globals.currentUser.username+'.', function(){
                    location.reload();
                });
                return true;
            }
            return false;
        }

        return service;
    }]);